// TODO: CLEANUP — This file was migrated from ITMarketplaceV2Website for the navbar header.
// It will need to be cleaned up once the shared header package is extracted.
export const SANDBOX = "sandbox";
export const DEV = "dev";
export const BETA = "beta";
export const GAMMA = "gamma";
export const PROD = "prod";
export const BASE_DOMAIN = "shop.it.a2z.com";

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class PERMISSIONS {
  public static BRAVE_HEART = "braveheart";
  public static USE_HARDWARE_SHOP = "use_hardware_shop";
  public static USE_HARDWARE_BASELINE = "use_hardware_baseline";
}

export interface SiteConfiguration {
  apiBaseUrl: string;
  itShopUrl: string;
  cfmConfig: string;
  v1BaseUrl: string;
  catalogServiceEndpoint: string;
  v2AdminUrl: string;
  ordering: OrderingConfig;
  region: string;
  analytics: AnalyticsConfig;
  useMyAssets: boolean;
  hopUrl: string;
  coupaUrl: string;
  amazonApprovalsUrl: string;
  useAIForMeAPIService: boolean;
}

export interface AnalyticsConfig {
  collectorDomain: string;
  appId: string;
  enabled: boolean;
  uxmAppId: string;
}

export interface OrderingConfig {
  itmpv1Endpoint: string;
  itoEndpoint: string;
}

export function getStage(baseDomain: string): string | undefined {
  if (BASE_DOMAIN === baseDomain) return PROD;
  else if (`${GAMMA}.${BASE_DOMAIN}` === baseDomain) return GAMMA;
  else if (`${BETA}.${BASE_DOMAIN}` === baseDomain) return BETA;
  else if (`${DEV}.${BASE_DOMAIN}` === baseDomain) return DEV;
  else if (`${SANDBOX}.${BASE_DOMAIN}` === baseDomain) return SANDBOX;
}

import betaConfig from "./configuration/config.beta.json";
import gammaConfig from "./configuration/config.gamma.json";
import prodConfig from "./configuration/config.prod.json";
import devConfig from "./configuration/config.dev.json";

/**
 * Loads stage-specific configuration.
 * For personal stacks, create src/configuration/config.local.json
 * (see config.local.example.json). Falls back to dev config if not found.
 */
export function getConfigByEnv(): SiteConfiguration {
  const hostname = typeof window !== "undefined" ? window.location.hostname : "";
  const stage = getStage(hostname.replace("hardware.", ""));

  switch (stage) {
    case PROD:
      return prodConfig as unknown as SiteConfiguration;
    case GAMMA:
      return gammaConfig as unknown as SiteConfiguration;
    case BETA:
      return betaConfig as unknown as SiteConfiguration;
    case DEV:
      return devConfig as unknown as SiteConfiguration;
    default: {
      // Personal stack: derive API URL from hostname pattern
      // e.g., "flresms-gem.dev.hardware.shop.it.a2z.com" → "api.flresms-gem.dev.hardware.shop.it.a2z.com"
      const personalStackMatch = hostname.match(/^(.+\.dev\.hardware\.shop\.it\.a2z\.com)$/);
      if (personalStackMatch) {
        return {
          ...devConfig as unknown as SiteConfiguration,
          apiBaseUrl: `https://api.${personalStackMatch[1]}`,
        };
      }
      // Local dev: load config.local.json (works with webpack-dev-server)
      try {
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        return require(/* webpackIgnore: true */ "./configuration/config.local.json") as SiteConfiguration;
      } catch {
        return devConfig as unknown as SiteConfiguration;
      }
    }
  }
}

export const config = getConfigByEnv();
export const API_BASE_URL = config.apiBaseUrl;
export const IT_SHOP_URL = config.itShopUrl;
export const getApiBaseUrl = (): string => config.apiBaseUrl;
export const ITMP_V2_ADMIN_URL = config.v2AdminUrl;
export const CATALOG_SERVICE_ENDPOINT = config.catalogServiceEndpoint;
export const CATALOGICAL_ENDPOINT = config.apiBaseUrl;
export const DEFAULT_SERVICE_REGION = config.region;

function getCookie(name: string): string | undefined {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts && parts.length === 2) return parts.pop()?.split(";").shift();
}

export const CATALOG_PROVIDER: string = getCookie("CatalogProvider") ?? "itmpv1";
